module.exports = __webpack_public_path__ + "img/16_004.2442c6cf.webp";